import { FC } from 'react';
import { cn } from '@new/lib';
import { Can } from '@new/casl';

import { HeaderSearch } from './Search';
import { CreateDropdown } from './CreateDropdown/CreateDropdown';
import { ProfileDropdown } from './ProfileDropdown/ProfileDropdown';
import { NotificationsButton } from '@new/features/notifications/components/NotificationsButton/NotificationsButton';
import { User } from '@teachur/http-client';

interface HeaderProps {
  user: User;
}

export const Header: FC<HeaderProps> = ({ user }) => {
  return (
    <header className={cn('h-21.25 p-5 px-6 gap-5', 'border-b border-(--neutral-black-NB100)')}>
      <div className="flex justify-end items-center gap-6 lg:gap-8">
        <Can I="create" a="Course">
          <CreateDropdown />
        </Can>
        <Can I="access" a="SearchBar">
          <div className="hidden md:block">
            <HeaderSearch />
          </div>
        </Can>

        <NotificationsButton />
        <ProfileDropdown user={user} />
      </div>
    </header>
  );
};
